import React from "react";
import { Link } from "react-router-dom";
import { IMAGES, STATS } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

export default function Cooperatives() {
  useReveal([]);
  return (
    <>
      <PageHero
        tag="Impact social"
        title="Nos <em>Coopératives</em>"
        subtitle="Derrière chaque flacon, le savoir-faire et la dignité des femmes artisanes de l'Atlas."
        image={IMAGES.cooperativesHero}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Nos coopératives" }]} />

      <section className="split reveal">
        <div className="split-img"><img src={IMAGES.splitWomen} alt="Coopérative de femmes" /></div>
        <div className="split-text">
          <p className="section-tag">Depuis 2019</p>
          <h2 className="section-title">Un partenariat <em>équitable.</em></h2>
          <p className="section-body">
            Nous travaillons directement avec quatre coopératives de femmes au Maroc, sans intermédiaire.
            Cette relation directe garantit une rémunération juste, des conditions de travail dignes et
            le financement de projets locaux : alphabétisation, accès aux soins, autonomie financière.
          </p>
          <p className="section-body">
            Chaque achat soutient concrètement ces communautés et perpétue des gestes transmis de mère en fille.
          </p>
        </div>
      </section>

      <div className="stats reveal">
        {STATS.map((s) => (
          <div className="stat-item" key={s.label}>
            <span className="stat-number">{s.number}</span>
            <span className="stat-label">{s.label}</span>
          </div>
        ))}
      </div>

      <section className="reviews-section reveal">
        <p className="section-tag">Notre engagement</p>
        <h2 className="section-title">Beauté <em>solidaire</em></h2>
        <p className="section-body" style={{ maxWidth: 600, margin: "0 auto 2rem" }}>
          Une partie de nos bénéfices est réinvestie dans des programmes d'éducation et de santé au sein
          des villages partenaires de l'Atlas.
        </p>
        <Link to="/collections/all" className="btn-primary">Soutenir la Maison</Link>
      </section>

      <NewsletterSection />
    </>
  );
}
